type Props = React.SVGProps<SVGSVGElement>

export default function CheckIcon({ width = 15, height = 12, ...rest }: Props) {
  return (
    <svg
      {...rest}
      width={width}
      height={height}
      fill='currentColor'
      viewBox='0 0 14 12'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M2.13828 5.48195C1.89666 5.48263 1.66017 5.5517 1.45617 5.68118C1.25217 5.81066 1.08899 5.99524 0.985517 6.21359C0.882045 6.43193 0.842506 6.67511 0.871474 6.91499C0.900443 7.15487 0.996735 7.38165 1.14921 7.56908L4.39963 11.5508C4.51553 11.6948 4.66408 11.8089 4.83296 11.8839C5.00185 11.9589 5.18617 11.9924 5.37064 11.9819C5.76517 11.9607 6.12137 11.7496 6.34846 11.4026L13.1004 0.528592C13.1015 0.526775 13.1027 0.52498 13.1039 0.523207C13.1672 0.425934 13.1467 0.233165 13.0159 0.112065C12.98 0.0788095 12.9376 0.05326 12.8915 0.03699C12.8453 0.02072 12.7963 0.0140739 12.7474 0.0174612C12.6986 0.0208486 12.651 0.0341976 12.6075 0.056686C12.564 0.0791745 12.5256 0.110326 12.4946 0.148223C12.4922 0.151202 12.4897 0.154137 12.4871 0.157027L5.6777 7.85067C5.65179 7.87995 5.62032 7.90379 5.58512 7.9208C5.54992 7.93781 5.51169 7.94766 5.47265 7.94977C5.43361 7.95188 5.39454 7.94622 5.35771 7.9331C5.32088 7.91998 5.28702 7.89968 5.2581 7.87337L2.99818 5.81682C2.76347 5.60166 2.45669 5.4822 2.13828 5.48195Z'
        fill='currentColor'
      />
    </svg>
  )
}
